import { createTrackerForCategory } from '@gonfalon/analytics/createTrackerForCategory';

const trackContactUs = createTrackerForCategory('Contact Us');

export const trackCreateSupportTicket = (component: string) =>
  trackContactUs('Create Support Ticket Clicked', { component });
